import { Flex, Icon, Text } from "@chakra-ui/react";
import React from "react";
import { IoCheckmarkCircle } from "react-icons/io5";

export type FullscreenNotificationProps = {
  message: string;
};

const FullscreenNotification: React.FC<FullscreenNotificationProps> = ({
  message,
}) => {
  return (
    <Flex
      position="absolute"
      top="4"
      left="50%"
      transform="translateX(-50%)"
      bg="green.500"
      color="white"
      px="4"
      py="2"
      borderRadius="full"
      alignItems="center"
      gap="2"
      zIndex="10"
      boxShadow="lg"
      animation="fadeIn 0.2s ease-out"
      sx={{
        "@keyframes fadeIn": {
          from: {
            opacity: 0,
            transform: "translateX(-50%) translateY(-8px)",
          },
          to: {
            opacity: 1,
            transform: "translateX(-50%) translateY(0)",
          },
        },
      }}
    >
      <Icon as={IoCheckmarkCircle} boxSize="5" />
      <Text fontSize="sm" fontWeight="medium">
        {message}
      </Text>
    </Flex>
  );
};

export default FullscreenNotification;
